
// NATIVE 


// INSTALLED 


// CUSTOM 
import { checkingPreload, unCheckingPreload } from '../loading';
import { activeTipoNovedadService, createTipoNovedadService, desactiveTipoNovedadService, 
         getAllTipoNovedadesByPaginateService, getAllTipoNovedadService, getTipoNovedadDetailService, updateTipoNovedadDetailService } from '../../services/tiponovedad.service';
import { setNovedadesTurnoRedux, storeNovedadesTurnoRedux } from './novedadesTurnoSlice';
import { activeNovedadTurnoService, createNovedadesTurnoService, desactiveNovedadesTurnoService, getAllNovedadesTurnoService, getNovedadesTurnoDataCreateService, getNovedadTurnoDetailEditService, getNovedadTurnoDetailService, updateNovedadTurnoService } from '../../services/novedadesTurno';
import { setEmployeSelectRedux } from '../employee';
import { storeTipoNovedadSelectRedux } from '../tipo_novedad';
import dayjs from 'dayjs';




export const getNovedadesTurnoStore = (): any => {

    return async( dispatch: any ) => {


      await dispatch( checkingPreload() );


      const result = await  getAllNovedadesTurnoService();
 
     
     
      dispatch( unCheckingPreload() );

      if ( result.ok ) {

          await dispatch( setNovedadesTurnoRedux(result.data) );

      }
      
      return result;
        
    }
}




export const getNovedadesTurnoDataCreateStore = (): any => {

  return async( dispatch: any ) => {
     

      await dispatch( checkingPreload() );

      const result = await  getNovedadesTurnoDataCreateService();

      
      if ( result.ok ) {

          await dispatch( setEmployeSelectRedux(result.data.empleados) );
          await dispatch( storeTipoNovedadSelectRedux(result.data.tipoNovedades) );

      }
      
      dispatch( unCheckingPreload() );

      return {};


  }


}


export const storeCreateNovedadesTurno = (novedadesTurno: any, percentage:any): any => {


    return async( dispatch: any ) => { 


      await dispatch( checkingPreload() );

      const start_minute = dayjs( novedadesTurno.horaNovedad).minute().toString();
      
      
      const startMinuteFormated = ( start_minute.length > 1 ) ? dayjs( novedadesTurno.horaNovedad).minute() : '0'+dayjs( novedadesTurno.horaNovedad).minute();

      const dataNovedadesTurno = { 
        empleado: (novedadesTurno.colaborador.value ) ? novedadesTurno.colaborador.value : '', 
        responsable: (novedadesTurno.responsable.value ) ? novedadesTurno.responsable.value : '', 
        tipoNovedad: (novedadesTurno.tipoNovedad.value ) ? novedadesTurno.tipoNovedad.value : '', 
        fecha_novedad: (novedadesTurno.fechaNovedad ) ? new Date(novedadesTurno.fechaNovedad)  : '', 
        hora_novedad: (novedadesTurno.horaNovedad ) ? dayjs( novedadesTurno.horaNovedad).hour().toString()+':'+startMinuteFormated : '', 
        descripcion: (novedadesTurno.description ) ? novedadesTurno.description : '',
      };


      const result = await  createNovedadesTurnoService(dataNovedadesTurno, percentage);

     
      if (result.ok) {

        await dispatch( setNovedadesTurnoRedux(result.data) );
        
      }
      
      dispatch( unCheckingPreload() );
      
      return result;



    }



}




export const storeDesActiveNovedadesTurno = (novedadadesTurnoId: string): any => {
    

  return async( dispatch: any ) => { 

      await dispatch( checkingPreload() );


      const result = await  desactiveNovedadesTurnoService(novedadadesTurnoId);

      
      dispatch( unCheckingPreload() );

      if ( result.ok ) {
                               
        await dispatch( setNovedadesTurnoRedux(result.data) );

      }

      return result;

  }

    
}




export const storeActiveNovedadTurno = (tipoNovedadId: string): any => {
  

  return async( dispatch: any ) => { 

      await dispatch( checkingPreload() );

      const result = await  activeNovedadTurnoService(tipoNovedadId);

      
      dispatch( unCheckingPreload() );

      if ( result.ok ) {
           
          await dispatch( setNovedadesTurnoRedux(result.data) );

      }

      return result;

  }

    
}






// export const getTipoNovedadByPagination = (page:number): any => {

//     return async( dispatch: any ) => {


//       await dispatch( checkingPreload() );
//       await dispatch( hideIconRequestErrors() );


//       const result = await  getAllTipoNovedadesByPaginateService(page);


//       if ( result.ok ) {
//           await dispatch( setTipoNovedadesRedux(result.data) );
//       }
    
//       dispatch( unCheckingPreload() );
      
//       return result;
        
//     }

// }



export const storeDetailNovedadTurno = (tipoNovedadId: string): any => {
    

  return async( dispatch: any ) => { 


      await dispatch( checkingPreload() );
      

      const result = await  getNovedadTurnoDetailService(tipoNovedadId);
    
      
      dispatch( unCheckingPreload() );


      if ( result.ok ) {           

            await dispatch( storeNovedadesTurnoRedux(result.data) );
      }

      return result;

  }

    
}




export const storeDetailEditNovedadTurno = (tipoNovedadId: string): any => {
    

  return async( dispatch: any ) => { 


      await dispatch( checkingPreload() );
      

      const result = await  getNovedadTurnoDetailEditService(tipoNovedadId);
    
      
      dispatch( unCheckingPreload() );


      if ( result.ok ) {           

            await dispatch( storeNovedadesTurnoRedux(result.data.new) );
            await dispatch( setEmployeSelectRedux(result.data.empleados) );
            await dispatch( storeTipoNovedadSelectRedux(result.data.tipoNovedades) );
      }

      return result;

  }

    
}






export const storeEditNovedadesTurno = (novedadTurno: any): any => {
    

  return async( dispatch: any ) => { 


      await dispatch( checkingPreload() );

     console.log('chimbala ',novedadTurno)
      
      
      const start_minute = dayjs( novedadTurno.e_horaNovedad).minute().toString();
      
      
      const startMinuteFormated = ( start_minute.length > 1 ) ? dayjs( novedadTurno.e_horaNovedad).minute() : '0'+dayjs( novedadTurno.e_horaNovedad).minute();

      const horaFormateada = novedadTurno.e_horaNovedad
                            ? dayjs(novedadTurno.e_horaNovedad, "hh:mm A").format("HH:mm:ss")
                            : "";

      const dataNovedadesTurno = { 
        newId: ( novedadTurno.novedadTurnoId ) ? novedadTurno.novedadTurnoId : '',
        empleado: (novedadTurno.e_colaborador.value ) ? novedadTurno.e_colaborador.value : '', 
        responsable: (novedadTurno.e_responsable.value ) ? novedadTurno.e_responsable.value : '', 
        tipoNovedad: (novedadTurno.e_tipoNovedad.value ) ? novedadTurno.e_tipoNovedad.value : '', 
        fecha_novedad: (novedadTurno.e_fechaNovedad ) ? novedadTurno.e_fechaNovedad : '', 
        hora_novedad: horaFormateada, //(novedadTurno.e_horaNovedad ) ? dayjs( novedadTurno.e_horaNovedad).hour().toString()+':'+startMinuteFormated : '', 
        descripcion: (novedadTurno.e_description ) ? novedadTurno.e_description : '',
      };

       console.log('dataNovedadesTurnodataNovedadesTurno ',dataNovedadesTurno)

      const result = await  updateNovedadTurnoService(dataNovedadesTurno);
    
      

      
      dispatch( unCheckingPreload() );
      
      if ( result.ok ) {

        await dispatch( setNovedadesTurnoRedux(result.data) );

      }



      return result;

  }

    
}







